'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
  if (!emptyImage) {
    emptyImage = new Image();
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  return emptyImage;
}


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/react-dnd-html5-backend/lib/getEmptyImage.js
// module id = 420
// module chunks = 0